import Events from '../../utilities/EventEmitter';
import { throttle } from 'lodash';
import { APP_EVENT_NAMES } from '../constants';

const driverLocationMap = new Map();
let locationUpdateControls = {
  shouldRunBatchUpdate: false,
  currentTerminalCode: null,
  intervalInMilliseconds: 0,
};

const setDriverLocation = (driverId, data) => {
  driverLocationMap.set(driverId?.toUpperCase(), data);
};

const deleteDriversLocationCache = (driverIds) => {
  driverIds.forEach((driverId) => {
    driverLocationMap.delete(driverId?.toUpperCase());
  });
};

const clearDriverLocationMappingCache = () => {
  driverLocationMap.clear();
};

// Emit batch driver location update event to listeners
const startBatchLocationUpdateCycle = throttle(() => {
  if (driverLocationMap.size !== 0 && locationUpdateControls.shouldRunBatchUpdate) {
    Events.emit(APP_EVENT_NAMES.DISPATCH.AddDriverLocation, new Map(driverLocationMap));
    clearDriverLocationMappingCache();
  }
}, locationUpdateControls.intervalInMilliseconds);

// Update the batch interval on terminal change based on a parameter from the API.
const setBatchLocationUpdateInterval = (intervalInMilliseconds) => {
  locationUpdateControls.intervalInMilliseconds = intervalInMilliseconds;
};

// Emit batch driver location update event to listeners
const setBatchLocationUpdateConfig = (locationUpdateProps) => {
  clearDriverLocationMappingCache();
  locationUpdateControls = {...locationUpdateControls, ...locationUpdateProps};
};

const locationUpdated = (terminalCode, driverId, lat, lng, eventTime) => {
  if (
    !locationUpdateControls.shouldRunBatchUpdate ||
    locationUpdateControls.currentTerminalCode !== terminalCode
  ) {
    return;
  }
  startBatchLocationUpdateCycle();
  setDriverLocation(driverId, { terminalCode, lat, lng, eventTime });
};

export {
  locationUpdated,
  setBatchLocationUpdateConfig,
  clearDriverLocationMappingCache,
  deleteDriversLocationCache,
  setBatchLocationUpdateInterval,
};
